import { CaseStudy } from "@/lib/dto/case-studies/case-studies";
import Head from "next/head";

interface CaseStudyMetaProps {
    caseStudy: CaseStudy;
}

export default function CaseStudyMeta({ caseStudy }: CaseStudyMetaProps) {
    const { companyName, industry, metaDescription, coverImage, link, pageTitle } = caseStudy;
    const documentTitle = pageTitle ?? `${companyName} Case Study - Devkrest`;
    const socialTitle = pageTitle ?? `${companyName} Case Study`;

    // Get the full URL for the cover image
    const coverImageUrl = typeof coverImage === 'string'
        ? coverImage
        : `${process.env.NEXT_PUBLIC_BASE_URL || 'https://devkrest.com'}${coverImage.src}`;

    // Get the full URL for the case study
    const fullUrl = `${process.env.NEXT_PUBLIC_BASE_URL || 'https://devkrest.com'}${link}`;

    return (
        <Head>
            {/* Basic Meta Tags */}
            <title>{documentTitle}</title>
            <meta name="description" content={metaDescription} />

            {/* Open Graph Meta Tags (Facebook, LinkedIn, etc.) */}
            <meta property="og:type" content="article" />
            <meta property="og:title" content={socialTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={coverImageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content="Devkrest" />

            {/* Twitter Card Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={socialTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={coverImageUrl} />
            <meta name="twitter:site" content="@devkrest" />

            {/* Additional Meta Tags */}
            <meta name="keywords" content={`${companyName}, case study, ${industry}, software development, Devkrest`} />
            <meta name="author" content="Devkrest" />

            {/* Canonical URL */}
            <link rel="canonical" href={fullUrl} />
        </Head>
    );
}
